import { ArrowDownSolid } from '@allocab/allocab-icons';

type Props = {
  oldValue?: string;
  newValue?: string;
};

export const DiffView = ({ oldValue, newValue }: Props) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <div className="text-red-500 mt-10 line-through bold text-center">{oldValue}</div>
      <ArrowDownSolid width={18} height={18} />
      <div className="text-green-700 text-center">{newValue}</div>
    </div>
  );
};
